module.exports = __webpack_public_path__ + "media/leaderboardSound.2803fbef.mp3";